import React, { useState } from "react";
import CTAButton from "../components/core/HomePage/Button";
import { useDispatch, useSelector } from "react-redux";
import { FaArrowLeft } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { getPasswordResetToken } from "../services/operations/authAPI";

function ForgotPassword(props) {
  const { loading } = useSelector((state) => state.auth);
  const [emailSent, setEmailSent] = useState(false); // check if the email is sent or not
  const [email, setEmail] = useState(""); // to store email
  const dispatch = useDispatch();

  function handleOnSumbit(e) {
    e.preventDefault();
    console.log("Hello");
    dispatch(getPasswordResetToken(email, setEmailSent));
  }

  return (
    <div className="flex w-full justify-center items-center">
      <div className="w-[50%] mt-[10rem] flex flex-col justify-center items-center">
        {loading ? (
          <div className='flex w-full h-screen justify-center items-center'>
            <div class="spinner"></div>
          </div>
        ) : (
          <div className="flex flex-col justify-center w-[50%] max-[450px]:w-[100%] gap-2">
            <h1 className="text-3xl text-richblack-25 font-semibold">
              {!emailSent ? "Reset your password" : "Check your password"}
            </h1>
            <p className="text-richblack-100 text-md">
              {!emailSent
                ? "Have no fear. We’ll email you instructions to reset your password. If you dont have access to your email we can try account recovery"
                : `We have sent the reset email to
                ${email}`}
            </p>
            <form onSubmit={handleOnSumbit}>
              {!emailSent && (
                <label className="gap-y-2 flex flex-col mt-4">
                  <p className="text-richblack-100">
                    Email Address <sup className="text-pink-200">*</sup>
                  </p>
                  <input
                    className="px-4 py-2 w-[100%] bg-richblack-800 rounded-md text-richblack-100"
                    type="email"
                    name="email"
                    value={email}
                    placeholder="Enter your email here"
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                </label>
              )}
              <button
                className="text-center w-full text-[13px] px-6 py-3 rounded-md font-bold 
            bg-yellow-50
            hover:scale-95 transition-all duration-200 mt-2"
                type="submit">
                {!email ? "Reset Password" : "Resend Email"}
              </button>
            </form>
            <div className="text-richblack-25">
              <Link to="/login" className="flex items-center gap-x-2">
                <FaArrowLeft /> <p>Back to Login</p>
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
